import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const cancelDocumentRequestMutation = gql`
  mutation cancelDocumentRequest(
    $customerId: String!
    $applicationId: String!
    $subjectId: String!
    $userId: String!
    $recommendationId: String!
    $notifyApplicant: Boolean!
  ) {
    cancelDocumentRequest(
      customerId: $customerId
      applicationId: $applicationId
      subjectId: $subjectId
      userId: $userId
      recommendationId: $recommendationId
      notifyApplicant: $notifyApplicant
    )
  }
`

export type MutationVars = {
  customerId: string
  applicationId: string
  subjectId: string
  userId: string
  recommendationId: string
  notifyApplicant: boolean
}

export type CancelDocumentRequestData = {
  cancelDocumentRequestData: string | unknown
}

export const useCancelDocumentRequestMutation: WrappedMutation<
  CancelDocumentRequestData,
  MutationVars
> = () =>
  useMutation<CancelDocumentRequestData, MutationVars>(cancelDocumentRequestMutation, {
    client: agentClient,
  })
